import * as React from "react";

function SvgRounded1Inverted(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path d="M1604.5-2.7l-10.9 104.5c-3.8 48.1-46.3 84.4-94.4 80.6L-8 61.8v148.5h1613.9l-1.4-213z" /></svg>;
}

export default SvgRounded1Inverted;